import { Component, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { UserService,ScrollService } from '../api/';
import { ToastyService } from 'ng2-toasty';
import { MdDialog } from '@angular/material';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements AfterViewInit, OnDestroy, OnInit {
  private activeLinkIndex = 0;
  mobileView:boolean = false;
  private activePackages = [];
  private tabLinks = [
    { label: 'My History', link: 'user-activities' },
    { label: 'Followers', link: 'followers' },
    { label: 'Following', link: 'following' },
    { label: 'Payments History', link: 'payment-history' },
    { label: 'My Subscriptions', link: 'my-packages' },
    { label: 'My Downloads', link: 'my-downloads' },
  ];
  private routerEvent = null;
  // to display the card section
  public showCard = false;

  constructor(private userService: UserService, private toastyService: ToastyService, public dialog: MdDialog, private router: Router,
    private route: ActivatedRoute,private scrollService: ScrollService) {
  }

  ngOnInit(){
    if(screen.width < 1025){
      this.mobileView = true;
    }
    this.scrollService.enableScrollIfDisabled();
  }
  
  ngAfterViewInit() {
    this.routerEvent = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        switch (event.url) {
          case '/dashboard':
            this.activeLinkIndex = 0;
            break;
          case '/dashboard/user-activities':
            this.activeLinkIndex = 0;
            break;
          case '/dashboard/followers':
            this.activeLinkIndex = 1;
            break;
          case '/dashboard/following':
            this.activeLinkIndex = 2;
            break;
          case '/dashboard/payment-history':
            this.activeLinkIndex = 3;
            this.showCard = true;
            break;
          case '/dashboard/my-packages':
            this.activeLinkIndex = 4;
            break;
          case '/dashboard/my-downloads':
            this.activeLinkIndex = 5;
            break;
        }
      }
    });
  }

  changeTab(event, param, i) {
    event.stopPropagation();
    event.preventDefault();
    this.activeLinkIndex = i;
    switch (i) {
      case 0:
        this.router.navigate(['user-activities'], { relativeTo: this.route });
        break;
      case 1:
        this.router.navigate(['followers'], { relativeTo: this.route });
        break;
      case 2:
        this.router.navigate(['following'], { relativeTo: this.route });
        break;
      case 3:
        this.router.navigate(['payment-history'], { relativeTo: this.route });
        break;
      case 4:
        this.router.navigate(['my-packages'], { relativeTo: this.route });
        break;
      case 5:
        this.router.navigate(['my-downloads'], { relativeTo: this.route });
        break;
    }
  }

  // to display the card when tab value is changed
  tabChanged(event) {
    if(event.index == 3) {
      this.showCard = true;
    } else {
      this.showCard = false;
    }
  }

  ngOnDestroy() {
    if (this.routerEvent != null) {
      this.routerEvent.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts